/* unplugin-vue-components disabled */import script from "./empty.vue?vue&type=script&setup=true&lang=js"
export * from "./empty.vue?vue&type=script&setup=true&lang=js"

import "./empty.vue?vue&type=style&index=0&id=0d8c1347&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d8c1347"]])

export default __exports__